import { useEffect, useState } from 'react'

export function useIsDesktop(breakpoint = 768) {
  const [isDesktop, setIsDesktop] = useState(false) // Always start with false for consistent hydration
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
    const media = window.matchMedia(`(min-width: ${breakpoint}px)`)
    const listener = () => setIsDesktop(media.matches)
    media.addEventListener('change', listener)
    setIsDesktop(media.matches)
    return () => media.removeEventListener('change', listener)
  }, [breakpoint])

  // Always return false during SSR and initial render to prevent hydration mismatch
  if (!isMounted) {
    return false
  }

  return isDesktop
} 